import script from "./ContentListItemTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentListItemTitle.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__